import React, {FC, useEffect, useRef, useState} from "react";
import {Typography, Collapse, Button} from "@mui/material";

type ExpandableDescriptionProps = {
	description: string | undefined;
	collapsedHeightMobile?: number;
	collapsedHeightDesktop?: number;
	color?: string;
};

export const ExpandableDescription: FC<ExpandableDescriptionProps> = ({
	description = "",
	collapsedHeightMobile = 76,
	collapsedHeightDesktop = 26,
	color = "#F9F9F9B2"
}) => {
	const textRef = useRef<HTMLParagraphElement>(null);
	const [expanded, setExpanded] = useState(false);
	const [lines, setLines] = useState(0);
	const isMobile = window.innerWidth <= 600;
	const collapsedSize = isMobile ? collapsedHeightMobile : collapsedHeightDesktop;
	const numberOfLinesToShow = isMobile ? 3 : 1;
	const isLongDescription = lines > numberOfLinesToShow;

	const calculateLines = () => {
		if (textRef.current) {
			const style = getComputedStyle(textRef.current);
			const lineHeight = parseFloat(style.lineHeight);
			const totalHeight = textRef.current.scrollHeight;
			setLines(Math.round(totalHeight / lineHeight));
		}
	};

	useEffect(() => {
		calculateLines();
		window.addEventListener("resize", calculateLines);
		return () => window.removeEventListener("resize", calculateLines);
	}, [description]);

	return (
		<>
			<Collapse in={expanded} collapsedSize={collapsedSize}>
				<Typography ref={textRef} variant="body1" color={color}>
					{description}
				</Typography>
			</Collapse>
			{isLongDescription && (
				<Button
					onClick={() => setExpanded((prev) => !prev)}
					sx={{
						textTransform: "none",
						color,
						textDecoration: "underline",
						marginTop: "-10px",
						marginLeft: "-8px"
					}}
				>
					{expanded ? "Show Less" : "Read More..."}
				</Button>
			)}
		</>
	);
};
